import { render, staticRenderFns } from "./Saq.vue?vue&type=template&id=cb3041d0"
import script from "./Saq.vue?vue&type=script&lang=js"
export * from "./Saq.vue?vue&type=script&lang=js"
import style0 from "./Saq.vue?vue&type=style&index=0&id=cb3041d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports